// extracted by mini-css-extract-plugin
export var footer = "styles-module--footer--3xk12";
export var inner = "styles-module--inner--33HrX";
export var companies = "styles-module--companies--1_XCa";
export var socials = "styles-module--socials--3a0sQ";
export var special = "styles-module--special--_6YPH";